{
  "dropLabel": "跳转到特定问题",
  "nextLabel": "<b>回答健康相关问题</b>",
  "questions": {
    "allergies": {
      "detailsPlaceholder": "请使用英文填写。例如：<br/>\nPenicillin – rash and swelling; Latex – mild irritation",
      "label": "您有任何过敏反应吗？",
      "nextLabel": "$t(common:next): <b>体重和身高</b>",
      "title": "<h3>过敏反应 (Allergies)</h3>"
    },
    "arrhythmias": {
      "detailsPlaceholder": "请用英文填写。例如： <br/>Irregular heartbeat, on beta blockers since 2021",
      "label": "您有心律不齐、心悸或心脏杂音吗？",
      "nextLabel": "$t(common:next): <b>起搏器</b>",
      "title": "<h3>心律不齐 (Arrhythmias)</h3>"
    },
    "asthmaLungConditions": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>\nMild asthma – use inhaler occasionally",
      "label": "您是否患有哮喘、慢性阻塞性肺病 (COPD) 或其他肺部疾病？",
      "nextLabel": "$t(common:next): <b>消化系统疾病</b>",
      "title": "<h3>哮喘或肺部疾病 (Asthma or lung conditions)</h3>"
    },
    "bloodProblems": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>Easy bruising – diagnosed with Von Willebrand disease",
      "label": "您是否患有胃食管反流病（GORD）、肠易激综合症（IBS）或炎症性肠病（IBD）？",
      "nextLabel": "$t(common:next): <b>器官移植</b>",
      "title": "<h3>血液疾病或出血问题 (Blood disorders or bleeding problems)</h3>"
    },
    "bloodThinningMedication": {
      "detailsPlaceholder": "请用英文填写。例如： <br/>Apixaban – 5mg daily, last taken on 3 June",
      "label": "您目前正在服用抗凝血药物吗？",
      "nextLabel": "$t(common:next): <b>心脏疾病</b>",
      "title": "<h3>抗凝血药物 (Blood thinning medication)</h3>"
    },
    "cancerTreatment": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>\nChemotherapy for breast cancer – ongoing",
      "label": "您目前是否正在接受化疗、放疗或任何其他癌症治疗？",
      "nextLabel": "$t(common:next): <b>传染病</b>",
      "title": "<h3>癌症治疗 (Cancer treatment)</h3>"
    },
    "diabetes": {
      "detailsLabel": "您的糖尿病是如何控制的？",
      "diet-controlled": "饮食控制",
      "insulin": "胰岛素",
      "label": "您有糖尿病吗？",
      "nextLabel": "$t(common:next): <b>高血压</b>",
      "no": "否",
      "tablets": "片剂（例如：二甲双胍",
      "title": "<h3>糖尿病 (Diabetes)</h3>",
      "type-1": "1型 – 使用胰岛素",
      "type-2": "2型",
      "yes-type-1": "是 – 1型，使用胰岛素",
      "yes-type-2": "是 – 2型"
    },
    "digestiveConditions": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>Reflux managed with omeprazole",
      "label": "您是否患有胃食管反流病（GORD）、肠易激综合症（IBS）或炎症性肠病（IBD）？",
      "nextLabel": "$t(common:next): <b>血液或出血问题</b>",
      "title": "<h3>消化系统疾病 (Digestive conditions)</h3>"
    },
    "epilepsy": {
      "detailsPlaceholder": "请使用英文填写。例如：<br/>\nLast seizure in 2020 – currently stable",
      "label": "您是否患有癫痫或有癫痫发作的病史？",
      "nextLabel": "$t(common:next): <b>神经系统疾病</b>",
      "title": "<h3>癫痫 (Epilepsy)</h3>"
    },
    "heartConditions": {
      "detailsPlaceholder": "请用英文填写。例如： <br/>Heart attack in 2020 – stent inserted",
      "label": "您是否曾经患有心脏疾病（例如心脏病发作、心绞痛）？",
      "nextLabel": "$t(common:next): <b>中风或TIA</b>",
      "title": "<h3>心脏疾病 (Heart conditions)</h3>"
    },
    "highBloodPressure": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>Diagnosed in 2018 – managed with medication",
      "label": "您有高血压吗？",
      "nextLabel": "$t(common:next): <b>心律不齐</b>",
      "title": "<h3>高血压 (High blood pressure)</h3>"
    },
    "infectiousDiseases": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>\nMRSA – cleared after treatment in 2021",
      "label": "您是否曾经被检测出 MRSA、ESBL、VRE 或 CPE 呈阳性？",
      "nextLabel": "$t(common:next): <b>怀孕</b>",
      "title": "<h3>多重耐药菌 (Multi-resistant organisms)</h3>"
    },
    "metalImplants": {
      "detailsPlaceholder": "请用英文填写。例如： <br/>Right hip replacement (2020), dental implants, or metal rod in leg",
      "label": "您的体内有金属植入物或金属器件吗？（例如：心脏起搏器或假体）",
      "nextLabel": "$t(common:next): <b>糖尿病</b>",
      "title": "<h3>植入物或金属 (Implants or metal)</h3>"
    },
    "obstructiveSleepApnoea": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>\nDiagnosed in 2022 – use CPAP machine every night",
      "label": "您是否患有阻塞性睡眠呼吸暂停症，或在晚上睡觉时使用 CPAP 机器？",
      "nextLabel": "$t(common:next): <b>哮喘或肺部疾病</b>",
      "title": "<h3>阻塞性睡眠呼吸暂停 (Obstructive Sleep Apnoea)</h3>"
    },
    "organTransplant": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>\nKidney transplant in 2018 – taking tacrolimus and prednisone",
      "label": "您是否接受过器官移植，并正在服用免疫抑制药物？",
      "nextLabel": "$t(common:next): <b>癌症治疗</b>",
      "title": "<h3>器官移植 (Organ transplant)</h3>"
    },
    "otherHealthConditions": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>\nCoeliac disease, recent surgery, chronic pain",
      "label": "您还有其他我们需要了解的健康状况或担忧吗？",
      "nextLabel": "$t(common:next): <b>药物</b>",
      "title": "<h3>其他健康状况 (Other health conditions)</h3>"
    },
    "pacemaker": {
      "defibrillator": "除颤器",
      "detailsLabel": "这是什么类型？",
      "label": "您有起搏器或其他植入式心脏装置吗？",
      "nextLabel": "$t(common:next): <b>抗凝药</b>",
      "not-sure": "我不确定",
      "pacing": "起搏器模式",
      "title": "<h3>起搏器或植入式心脏装置 (Pacemaker or implanted cardiac device)</h3>"
    },
    "pregnancy": {
      "label": "您现在是否怀孕，或可能怀孕？",
      "nextLabel": "$t(common:next): <b>其他情况</b>",
      "title": "<h3>怀孕 (Pregnancy)</h3>"
    },
    "stroke": {
      "detailsPlaceholder": "请使用英文填写。例如：<br/>\nStroke in 2021 – mild weakness on left side",
      "label": "您曾经中风或轻微中风（TIA）吗？",
      "nextLabel": "$t(common:next): <b>癫痫（Epilepsy）</b>",
      "title": "<h3>中风或短暂性脑缺血发作（TIA）</h3>"
    },
    "weightHeight": {
      "cm": "cm",
      "height": "身高",
      "kg": "kg",
      "nextLabel": "$t(common:next): <b>植入物 / 金属</b>",
      "text": "请输入您的大致体重和身高。",
      "title": "<h3>体重和身高</h3><p>请输入您的大致体重和身高。</p>",
      "weight": "体重"
    }
  },
  "text": "<p>我们快完成了。</p>\n<p>我们需要了解一些关于您的健康状况、用药情况和个人偏好的问题。</p>\n<p>了解任何可能影响您护理的情况非常重要。</p>\n<p>如果有需要确认的地方，我们的团队成员将在您的检查前与您联系。</p>\n<p>这个最后的步骤通常少于<strong>10分钟</strong>即可完成。</p>",
  "title": "健康和偏好问题"
}
